import {ANALYZE_FOR_ENTRY_COMPONENTS, Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import * as Highcharts from 'highcharts';
import {ChartService} from "./chart-service";
import {DeviceDetectorService} from "ngx-device-detector";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import {ActivatedRoute} from "@angular/router";
import notify from "devextreme/ui/notify";
@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {

  documentos: any = [];
  leyenda: string;
  classLeyenda: string;
  styleLeyenda: string;
  src: string;
  domain: string;
  popupVisible: boolean;
  tabs: any = [
    {id:1, title:'Ejecución Histórica'},
    {id:2, title:'Ejecución Acumulada Anual'}
  ];
  scripts: any= [
    {uri: 'https://code.highcharts.com/mapdata/countries/bo/bo-all.js'}

  ];
  data1: any = {xAxis: {categories: []}, series: []};
  data2: any = {xAxis: {categories: []}, series: []};
  data3: any = {xAxis: {categories: []}, series: []};
  data4: any = {xAxis: {categories: []}, series: []};
  data5: any = {};
  data6: any = {};
  data7: any = {};
  data8: any = {};
  data9: any = {};
  data10: any = {};
  data11: any = {};
  data12: any = {};

  mapa: any = {};
  content: any;
  menu1: any = [];
  menu2: any = [];
  menu1Selected: number;
  menu2Selected: number;
  expanded: any = [];
  Highcharts = Highcharts;
  chartOptions: any;
  chartOptions2: any;
  chartOptions3: any;
  chartOptions4: any;
  chartOptions5: any;
  chartOptions6: any;
  chartOptions7: any;
  chartOptions8: any;
  chartOptions9: any;
  chartOptions10: any;
  chartOptions11: any;
  chartOptions12: any;
  chartOptions13: any;
  chartOptions14: any;
  chartOptions15: any;
  chartOptions16: any;
  chartOptions17: any;
  chartOptions18: any;
  chartOptions19: any;
  chartOptions20: any;
  title: string;
  subTitle: string;
  pdfSrc: SafeUrl ;
  tipo: any = [];
  tipoSelected: string;
  departamento: any = {id:0, departamento:''};
  departamentos: any = [];
  dataDep1: any;
  dataDep2: any;
  dataDep3: any;
  dataDep4: any;
  dataDep5: any;
  dataDep6: any;
  dataDep7: any;
  dataDep8: any;
  dataDep9: any;
  dep1: any;
  dep2: any;
  dep3: any;
  dep4: any;
  dep5: any;
  dep6: any;
  dep7: any;
  dep8: any;
  dep9: any;
  isMobile: any;
  isTablet: any;
  isDesktopDevice: any;
  width: string;
  width1: number;
  widthTable: string;
  chartOptionsX: any;
  loadingVisible: boolean;
  i: number = 0;
  @ViewChild('iframe') iframe: ElementRef;
  @HostListener('window:resize') onResize(e) {
    // guard against resize before view is rendered
    console.log('W:',this.width);
    //this.width = window.innerWidth - 200 + 'px';
  }
  constructor(private service: ChartService, private route: ActivatedRoute, public sanitizer: DomSanitizer, private deviceService: DeviceDetectorService) {
    this.leyenda = '(*) Los totales pueden diferir por el redondeo al segundo decimal';
    this.classLeyenda = 'text-center';
    this.styleLeyenda = '';
    this.menu1Selected = 0;
    this.menu2Selected = 4;
    this.menu1 = [
      {
        id:1,
        nombre: '1. Evolución General',
        text: '1. Evolución General',
        icon: 'icon',
      },
      {
        id:2,
        nombre: '2. Inversión con relación al PIB',
        text: '2. Inversión con relación al PIB',
        icon: 'icon',
      },
      {
        id:3,
        nombre: '3. Participación de la Ejecución',
        text: '3. Participación de la Ejecución',
        icon: 'icon',
      },
      {
        id:4,
        nombre: '4. Evolución Departamental',
        text: '4. Evolución Departamental',
        icon: 'icon',
      },
      /*{
        id:5,
        nombre: '5. Ejecución Estatal',
        text: '5. Ejecución Estatal',
        icon: 'icon',
      }*/
    ];
    this.menu2 = [
      {
        id:4,
        nombre: '1. Comparativo histórico',
        text: '1. Comparativo histórico',
        icon: 'icon',
      },
      {
        id:0,
        nombre: '2. Resumen Institucional',
        text: '2. Resumen Institucional',
        icon: 'icon',
      },
      {
        id:3,
        nombre: '3. Detalle Institucional',
        text: '3. Detalle Institucional',
        icon: 'icon',
      },
      {
        id:1,
        nombre: '4. Resumen Sectorial',
        text: '4. Resumen Sectorial',
        icon: 'icon',
      },
      {
        id:2,
        nombre: '5. Resumen Departamental',
        text: '5. Resumen Departamental',
        icon: 'icon',
      }
    ];

    this.content = [];//GRILLA


    this.tipo = [
      'Bolivianos',
      'Dólares'
    ];
    this.departamentos = [
      {id:1, departamento: 'CHUQUISACA', idservice: 10},
      {id:2, departamento: 'LA PAZ', idservice: 11},
      {id:3, departamento: 'COCHABAMBA', idservice: 12},
      {id:4, departamento: 'ORURO', idservice: 13},
      {id:5, departamento: 'POTOSI', idservice: 14},
      {id:6, departamento: 'TARIJA', idservice: 15},
      {id:7, departamento: 'SANTA CRUZ', idservice: 16},
      {id:8, departamento: 'BENI', idservice: 17},
      {id:9, departamento: 'PANDO', idservice: 18}
    ];
    this.departamento = this.departamentos[0].id;
    this.tipoSelected = this.tipo[0];
  }

  evento(e) {
    console.log(this.isMobile, e);
    if(this.isMobile) {
      window.location.href = e.point.url;
    } else {
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(e.point.url);
      try{
        this.popupVisible = true;
      }catch(e) {
        notify('El documento no existe', 'error', 2000);
      }
    }
  }
  openDoc(e) {
    console.log(this.isMobile, e);
    if(this.isMobile) {
      window.location.href = e.point.url;
    } else {
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(e);
      try{
        this.popupVisible = true;
      }catch(e) {
        notify('El documento no existe', 'error', 2000);
      }
    }
  }
  testX() {

    setInterval(()=> {
      this.i++;
      this.service.getCharts(this.i).subscribe(response => {
        this.chartOptionsX = response;
      });

    }, 5000);

  }
  getChartDep(idDep) {
    this.service.getCharts(idDep).subscribe(response => {
      this.dep1 = response;
      this.dep1.plotOptions.series.point.events.click = (e) => {this.evento(e);};
      console.log(this.dep1.plotOptions.series.point.events.click);
    });
  }
  getCharts(tabParentIndex, tabIndex) {
    this.loadingVisible = true;
    console.log(tabParentIndex, tabIndex);
    if(tabParentIndex == 0 && tabIndex == 0) {
      this.service.getCharts(1).subscribe(response => {
        this.chartOptions = response;
        this.chartOptions.plotOptions.series.point.events.click = (e) => {this.evento(e);};
        this.service.getCharts(2).subscribe(response => {
          this.chartOptions2 = response;
          this.chartOptions2.plotOptions.series.point.events.click = (e) => {this.evento(e);};
          this.service.getCharts(8).subscribe(response => {
            this.chartOptions3 = response;
            this.chartOptions3.plotOptions.series.point.events.click = (e) => {this.evento(e);};
            this.service.getCharts(6).subscribe(response => {
              this.chartOptions10 = response;
              this.chartOptions10.plotOptions.series.point.events.click = (e) => {this.evento(e);};
              this.service.getCharts(7).subscribe(response => {
                this.chartOptions11 = response;
                this.chartOptions11.plotOptions.series.point.events.click = (e) => {this.evento(e);};
                this.service.getCharts(9).subscribe(response => {
                  this.chartOptions12 = response;
                  this.chartOptions12.plotOptions.series.point.events.click = (e) => {this.evento(e);};
                  this.loadingVisible = false;
                });
              });
            });
          });
        });
      });





    }
    if(tabParentIndex == 0 && tabIndex == 1) {
      this.service.getCharts(20).subscribe(response => {
        this.chartOptions7 = response;
        this.service.getCharts(30).subscribe(response => {
          this.chartOptions20 = response;
          this.loadingVisible = false;
        });
      });
    }
    if(tabParentIndex == 0 && tabIndex == 2) {
      this.service.getCharts(19).subscribe(response => {
        this.chartOptions8 = response;
        this.chartOptions8.plotOptions.series.point.events.click = (e) => {this.evento(e);};
        this.service.getCharts(24).subscribe(response => {
          this.chartOptions15 = response;
          this.chartOptions15.plotOptions.series.point.events.click = (e) => {this.evento(e);};
          this.service.getCharts(25).subscribe(response => {
            this.chartOptions16 = response;
            this.chartOptions16.plotOptions.series.point.events.click = (e) => {this.evento(e);};
            this.loadingVisible = false;
          });
        });
      });
    }
    if(tabParentIndex == 0 && tabIndex == 4) {
      this.service.getCharts(23).subscribe(response => {
        this.chartOptions14 = response;
        this.service.getCharts(29).subscribe(response => {
            this.chartOptions19 = response;
            this.loadingVisible = false;
        });
      });
    }
    if(tabParentIndex == 1 && tabIndex == 0) {
      this.service.getCharts(3).subscribe(response => {
        this.chartOptions4 = response;
        this.chartOptions4.plotOptions.series.point.events.click = (e) => {this.evento(e);};
        this.service.getCharts(27).subscribe(response => {
          this.chartOptions18 = response;
          this.loadingVisible = false;
        });
      });
    }
    if(tabParentIndex == 1 && tabIndex == 1) {
      this.service.getCharts(4).subscribe(response => {
        this.chartOptions5 = response;
        this.chartOptions5.plotOptions.series.point.events.click = (e) => {this.evento(e);};
        this.service.getCharts(28).subscribe(response => {
          this.chartOptions17 = response;
          this.loadingVisible = false;
        });
      });
    }
    if(tabParentIndex == 0 && tabIndex == 3) {
      this.loadingVisible = false;
    }
    if(tabParentIndex == 1 && tabIndex == 2) {
      this.loadingVisible = false;
    }
    if(tabParentIndex == 1 && tabIndex == 3) {
      this.service.getData().subscribe(response => {
        this.content = response;
        this.loadingVisible = false;
      });
      /*this.content.forEach( item => {
        this.expanded.push(item.id);
      });*/
    }
    if(tabParentIndex == 1 && tabIndex == 4) {
      this.service.getCharts(22).subscribe(response => {
        this.chartOptions13 = response;
        this.loadingVisible = false;
      });
    }

  }
  ngOnInit() {
    let qs = document.querySelectorAll('.slide-up');
    qs[0]['style'].display = "none";
    let qs1 = document.querySelectorAll('.main-bar');
    qs1[0]['style'].display = "none";
    let qs2 = document.querySelectorAll('.breadcrumb-row');
    qs2[0]['style'].display = "none";
    let qs4;
    setInterval(() => {
      qs4 = document.querySelectorAll('.site-footer');
      console.log(qs4);
      if(qs4 != undefined) {
        qs4[0]['style'].display = "none";
      }
    }, 200);

    Highcharts.setOptions({
      lang: {
        thousandsSep: ', ',
        decimalPoint: '.'
      }
    });
    this.getCharts(0, 0);
    this.getCharts(1, 4);
    this.getChartDep(10);
    this.service.getCharts(21).subscribe(response => {
      this.title = response['title']['text'];
      this.subTitle = response['subtitle']['text'];
    });
    window.addEventListener('message', this.handleIframeTask);
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
    console.log(this.isMobile, this.isTablet, this.isDesktopDevice);
    if(this.isMobile || this.isTablet) {
      this.width = window.innerWidth - 80 + 'px';
      this.widthTable = window.innerWidth - 80 + 'px';
      this.width1 = window.innerWidth - 70;
    } else {
      var d = document.getElementsByClassName('container');
      let e: Element = d.item(3);
      console.log('->->->',e['offsetWidth']);
      this.width = e['offsetWidth'] - 80 + 'px';
      this.width1 = Number(e['offsetWidth']) - 50;
      //this.widthTable = this.width;
    }
    console.log('->->->',window.innerWidth);
  }

  onDepartamentoChanged(e) {

    this.departamento = e.value;
    let dep = this.departamentos.find( item => item.id == e.value);
    console.log(dep);
    this.getChartDep(dep.idservice);
  }
  onValueChanged(e) {
    this.tipoSelected = e.value;
  }
  handleIframeTask = (e) => {
    try{
      if(e.data.indexOf("http") >= 0) {
        this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(e.data);
        try{
          this.popupVisible = true;
        }catch(e) {
          notify('El documento no existe', 'error', 2000);
        }
      }
    }catch(e) {

    }


    console.log(e);
  };
  menu1Click(e) {
    console.log(e.itemIndex);
    this.getCharts(0, e.itemIndex);
    this.menu1Selected = e.itemIndex;
  }
  menu2Click(e) {
    this.getCharts(1, e.itemData.id);
    this.menu2Selected = e.itemData.id;
  }
  screen(width) {
    return ( width < 700 ) ? 'sm' : 'lg';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/chart/chart.component.ts